var _path, _path2, _path3, _mask, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgShell = function SvgShell(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 48 36",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ccc",
    d: "M0 7h16V0H2C.9 0 0 .9 0 2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#999",
    d: "M32 0H16v7h16z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    d: "M48 7H32V0h14c1.1 0 2 .9 2 2z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#shell_svg__a)",
    d: "M46 36H2c-1.1 0-2-.9-2-2V6h48v28c0 1.1-.9 2-2 2z",
    style: {
      fill: "url(#shell_svg__a)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#shell_svg__b)",
    transform: "translate(0 -6)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#shell_svg__c)",
    d: "m15.2 24.3-8.8 8.8c-.5.5-.5 1.2 0 1.6l1.8 1.8c.5.5 1.2.5 1.6 0l8.8-8.8c.5-.5.5-1.2 0-1.6l-1.8-1.8c-.4-.4-1.2-.4-1.6 0z",
    style: {
      fill: "url(#shell_svg__c)"
    }
  }), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "shell_svg__e",
    width: 13,
    height: 13,
    x: 6,
    y: 24,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#shell_svg__d)",
    d: "m15.2 24.3-8.8 8.8c-.5.5-.5 1.2 0 1.6l1.8 1.8c.5.5 1.2.5 1.6 0l8.8-8.8c.5-.5.5-1.2 0-1.6l-1.8-1.8c-.4-.4-1.2-.4-1.6 0z"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#shell_svg__f)",
    mask: "url(#shell_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#shell_svg__g)",
    d: "m9.8 17.3 8.8 8.8c.5.5.5 1.2 0 1.6l-1.8 1.8c-.5.5-1.2.5-1.6 0l-8.8-8.8c-.5-.5-.5-1.2 0-1.6l1.8-1.8c.4-.4 1.2-.4 1.6 0Z",
    style: {
      fill: "url(#shell_svg__g)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#shell_svg__h)",
    d: "m9.8 17.3 8.8 8.8c.5.5.5 1.2 0 1.6l-1.8 1.8c-.5.5-1.2.5-1.6 0l-8.8-8.8c-.5-.5-.5-1.2 0-1.6l1.8-1.8c.4-.4 1.2-.4 1.6 0Z",
    style: {
      fill: "url(#shell_svg__h)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#shell_svg__i)",
    transform: "translate(0 -6)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#shell_svg__j)",
    d: "M40 32H24c-.6 0-1 .4-1 1v3c0 .6.4 1 1 1h16c.6 0 1-.4 1-1v-3c0-.6-.4-1-1-1z",
    style: {
      fill: "url(#shell_svg__j)"
    }
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "shell_svg__a",
    x1: 36.446,
    x2: 11.822,
    y1: 47.826,
    y2: 5.175,
    gradientTransform: "translate(0 -6)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D4D4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "shell_svg__c",
    x1: 14.528,
    x2: 10.484,
    y1: 33.996,
    y2: 26.992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "shell_svg__d",
    x1: 14.528,
    x2: 10.484,
    y1: 33.996,
    y2: 26.992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "shell_svg__g",
    x1: 16.275,
    x2: 8.737,
    y1: 30.034,
    y2: 16.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "shell_svg__h",
    x1: 16.275,
    x2: 8.737,
    y1: 30.034,
    y2: 16.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "shell_svg__j",
    x1: 35.15,
    x2: 28.85,
    y1: 39.955,
    y2: 29.045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "shell_svg__b",
    width: 18.95,
    height: 25.875,
    x: 3.025,
    y: 15,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow",
    result: "effect2_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect2_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "shell_svg__f",
    width: 18.95,
    height: 18.875,
    x: 3.025,
    y: 15,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow",
    result: "effect2_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect2_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "shell_svg__i",
    width: 24,
    height: 11,
    x: 20,
    y: 30,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow",
    result: "effect2_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect2_dropShadow",
    result: "shape"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgShell);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;